import loginSaga from './loginSaga'
import portfolioSaga from './portfolioSaga'
import simulationSaga from './simulationSaga'
export default [...loginSaga, ...portfolioSaga, ...simulationSaga]
